var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContrast = function SvgContrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 72C54.3652 72 60.4697 69.4714 64.9706 64.9706C69.4714 60.4697 72 54.3652 72 48C72 41.6348 69.4714 35.5303 64.9706 31.0294C60.4697 26.5286 54.3652 24 48 24V72Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgContrast;